import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import styles from './EcsPortal.module.scss';
import PaymentBounce from './PaymentBounce';
import PrcHome from './prc/PrcHome';
import ECSClearanceHistory from './ECSClearanceHistory';
import ModifyEcs from './ModifyEcs';
import FaqTicketCreate from '../common/FaqTicketCreate';
import { clickTracker } from '../../lib/common';
import { handleShowTagsFeedback } from '../../reducersAndActions/actions/appStateActions';
import { useAppState } from '../../contexts/appState';
import { handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

export default function EcsFaqs({
  faqdetails,
  campaigndetails,
  status,
  amount,
  redirectUrl,
  getAllEcsDetails,
  ecsdetails,
  projectId,
}) {
  let searchQid = '';
  searchQid = localStorage.getItem('searchQid');
  const [activeIndex, setActiveIndex] = useState(-1);
  const [curretItem, setCurentItem] = useState();
  const [faqData, setFaqData] = useState(faqdetails || []);
  const [, appDispatch] = useAppState();

  const [helpfulfaqKeys, setSearchQuestionelpfulFaqkeys] = useState({
    ...JSON.parse(sessionStorage.getItem('faqsFeedback')),
  });

  const [showData, setShowData] = useState(false);
  const [currentPrcType, setCurrentPrcType] = useState('');
  const [ishelful, setIsHelful] = useState(false);
  const [authState] = useAuth();

  const [data, setData] = useState({
    campaigns: {},
    reasons: '',
    otp: '',
    disadvantage: 'disadvantage',
  });

  const content = useRef(null);
  const handleSaveSessionStorage = () => {
    sessionStorage.setItem('faqsFeedback', JSON.stringify({ ...helpfulfaqKeys }));
  };
  const _prcClicks = {
    stop: { LL: 'ecs_FAQ', Li: 'FAQ_stop' },
    cancel: { LL: 'ecs_FAQ', Li: 'FAQ_cancelecs' },
    reactivate: { LL: 'ecs_FAQ', Li: 'FAQ_reactivate' },
  };
  const nonprcobj = {
    sales: {},
    bounce: { LL: 'ecs_FAQ', Li: 'FAQ_paybounced' },
    'ecs-clearance': { LL: 'ecs_FAQ', Li: 'FAQ_clearanceinfo' },
    modify: { LL: 'ecs_FAQ', Li: 'FAQ_modify' },
  };

  useEffect(() => {
    if (curretItem) {
      const includedarr = ['bounce', 'ecs-clearance'];
      if (!includedarr.includes(curretItem.type)) {
        setIsHelful(false);
      } else {
        let _ishelful = ishelful;
        _ishelful = true;
        setIsHelful(_ishelful);
      }
    }
  }, [curretItem]);
  const handleClickTrackers = async (item) => {
    setCurentItem(item);
    if (item.type === 'prc') {
      await clickTracker(_prcClicks[item.extraText].Li, _prcClicks[item.extraText].LL);
    } else await clickTracker(nonprcobj[item.type].Li, nonprcobj[item.type].LL);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `faq_${item?.faqKey}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = 'issue_ecs';
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
  };

  const handleFaqClick = async (item, index) => {
    handleShowTagsFeedback(appDispatch, {});
    if (activeIndex === index)
      await clickTracker('ecs_FAQ_feedback', `FAQ_${item.type === 'prc' ? item.extraText : item.type}_yes`);
    else await clickTracker('ecs_FAQ_feedback', `FAQ_${item.type}_no`);
    setShowData(true);
    setCurrentPrcType(item.type === 'prc' ? item.extraText : item.type);
    setActiveIndex(index === activeIndex ? -1 : index);
    handleClickTrackers(item);
  };

  const handleSearchFaq = () => {
    if (searchQid && searchQid !== '') {
      const faqsData = faqData;
      faqsData?.forEach((ele, i) => {
        if (ele?.id?.toString() === searchQid) {
          faqsData?.splice(i, 1);
          faqsData?.unshift(ele);
        }
      });

      faqsData?.forEach((faq, i) => {
        if (faq?.id?.toString() === searchQid) {
          handleFaqClick(faq, i);
        }
      });
      setFaqData(faqsData);
    }
  };

  useEffect(() => {
    handleSearchFaq();
  }, []);

  useEffect(() => {
    const handleSalesClickTracker = async () => {
      if (showData) {
        if (currentPrcType === 'sales') {
          await clickTracker('FAQ_infonotgiven', 'ecs_FAQ');
        }
      }
    };
    handleSalesClickTracker();
  }, [showData]);

  return (
    <div className="p-20">
      <div className="font16 fw700 color111 mb-20">Manage ECS</div>

      <div className={`${styles.Accordion__Box}`}>
        <div className={`${styles.Accordion__Pannel} `}>
          {faqData.map((item, index) => {
            return (
              <>
                {Object.keys(item).length > 0 && (
                  <div key={index + item}>
                    <div
                      aria-label="ecs_faqchange"
                      tabIndex={0}
                      role="button"
                      onKeyDown={() => {}}
                      className={`${styles.Accordion__Pannel__Heading} ${activeIndex === index ? styles.active : ''}`}
                      onClick={async () => {
                        handleShowTagsFeedback(appDispatch, {});
                        if (activeIndex !== index) {
                          handleClickTrackers(item);
                        }
                        setShowData(true);
                        setCurrentPrcType(item.type === 'prc' ? item.extraText : item.type);
                        setActiveIndex(index === activeIndex ? -1 : index);
                        setData({
                          campaigns: {},
                          reasons: '',
                          otp: '',
                          disadvantage: 'disadvantage',
                        });
                      }}
                    >
                      <div
                        className={`${styles.Accordion__Pannel__Title} font13 fw500 color111`}
                        style={{ marginBottom: '10px' }}
                      >
                        {item.question}
                      </div>
                      <div className={`${styles.Accordion__Pannel__Icon} csicon`} />
                    </div>
                    <div className={`${styles.Accordion__Contant} mt-8`} ref={content} style={{ maxHeight: `0px` }}>
                      <div className={`${styles.Accordion__TextContant} `}>
                        <>
                          {showData && curretItem?.pop === item?.pop ? (
                            <div>
                              {item.type === 'sales' ? (
                                <FaqTicketCreate
                                  issue={item.issue}
                                  subIssue={item.subIssue}
                                  activeIndex={activeIndex}
                                  currentPrcType={currentPrcType}
                                  vertical="RETENTION"
                                  category="CS"
                                  ticketCreator="BUSINESS"
                                  hideAlert
                                  hideCrossIcon
                                  id="ecs"
                                  faqObj={item}
                                />
                              ) : item.type === 'bounce' ? (
                                <PaymentBounce
                                  _href={item.replaceUrl}
                                  activeIndex={activeIndex}
                                  redirectUrl={redirectUrl}
                                  setIsHelful={setIsHelful}
                                  projectId={projectId}
                                  faqObj={item}
                                />
                              ) : item.type === 'prc' ? (
                                <PrcHome
                                  setIsHelful={setIsHelful}
                                  activeIndex={activeIndex}
                                  campaigndetails={campaigndetails}
                                  ecsdetails={ecsdetails}
                                  status={status}
                                  amount={amount}
                                  question={item.question}
                                  issue={item.issue}
                                  subIssue={item.subIssue}
                                  currentPrcType={currentPrcType}
                                  showData={showData}
                                  getAllEcsDetails={getAllEcsDetails}
                                  faqdetails={faqdetails}
                                  projectId={projectId}
                                  faqObj={item}
                                  data={data}
                                  setData={setData}
                                />
                              ) : item.type === 'ecs-clearance' ? (
                                <ECSClearanceHistory
                                  activeIndex={activeIndex}
                                  setIsHelful={setIsHelful}
                                  projectId={projectId}
                                />
                              ) : (
                                item.type === 'modify' && (
                                  <ModifyEcs
                                    setShowData={setShowData}
                                    showData={showData}
                                    activeIndex={activeIndex}
                                    projectId={projectId}
                                    faqObj={item}
                                  />
                                )
                              )}
                            </div>
                          ) : (
                            <>
                              {helpfulfaqKeys[index] && helpfulfaqKeys[index].notHelpul && (
                                <div className="mb-20 mt-20">
                                  <FaqTicketCreate
                                    issue={item.issue}
                                    subIssue={item.subIssue}
                                    activeIndex={activeIndex}
                                    vertical="RETENTION"
                                    category="CS"
                                    currentPrcType={currentPrcType}
                                    setShowData={setShowData}
                                    ticketCreator="BUSINESS"
                                    setIsHelful={setIsHelful}
                                    id="ecs"
                                    faqObj={item}
                                  />
                                </div>
                              )}
                            </>
                          )}
                        </>

                        {((ishelful && showData) || (projectId === 'genio' && item?.type === 'bounce' && showData)) && (
                          <div
                            className={`${styles.Helpful__Right}`}
                            style={{ justifyContent: 'flex-end', marginTop: '20px' }}
                          >
                            <div className="font11 fw400 color777">Was this Helpful?</div>
                            <div
                              aria-label="ecs_ishelpful_change"
                              tabIndex={0}
                              role="button"
                              onKeyDown={() => {}}
                              className={`${styles.Accordion__ThumbUp} ${
                                helpfulfaqKeys[index] && helpfulfaqKeys[index].helpful ? styles.active : ''
                              } csicon ml-14`}
                              onClick={async () => {
                                const isGenioEcsBouncedFaq = projectId === 'genio' && item.type === 'bounce';
                                const isGenioEcsClearanceFaq = projectId === 'genio' && item.type === 'ecs-clearance';
                                await clickTracker(
                                  `FAQ_${
                                    item.type === 'prc'
                                      ? item.extraText
                                      : isGenioEcsBouncedFaq
                                        ? 'paybounced'
                                        : isGenioEcsClearanceFaq
                                          ? 'clearanceinfo'
                                          : item.type
                                  }_yes`,
                                  'ecs_FAQ_feedback',
                                );
                                if (projectId === 'csportal') {
                                  const liVal = 'click';
                                  const liTrd = `faq_helpful`;
                                  const faqTypeVal = '';
                                  const othersData = [];
                                  const llTrd = `issue_ecs`;
                                  const llTrdInside = `faq_${item?.faqKey}`;
                                  await handleImpressionsTrack(
                                    liVal,
                                    liTrd,
                                    faqTypeVal,
                                    othersData,
                                    llTrd,
                                    authState,
                                    llTrdInside,
                                  );
                                }
                                helpfulfaqKeys[index] = { helpful: true, notHelpul: false };
                                setSearchQuestionelpfulFaqkeys({
                                  ...helpfulfaqKeys,
                                  [index]: { helpful: true, notHelpul: false },
                                });
                                setShowData(true);
                                handleSaveSessionStorage();
                              }}
                            />

                            <div
                              aria-label="ecs_helpfull"
                              tabIndex={0}
                              role="button"
                              onKeyDown={() => {}}
                              className={`${styles.Accordion__ThumbDown} ${
                                helpfulfaqKeys[index] && helpfulfaqKeys[index].notHelpul ? styles.active : ''
                              } csicon ml-14`}
                              onClick={async () => {
                                const isGenioEcsBouncedFaq = projectId === 'genio' && item.type === 'bounce';
                                const isGenioEcsClearanceFaq = projectId === 'genio' && item.type === 'ecs-clearance';
                                await clickTracker(
                                  `FAQ_${
                                    isGenioEcsBouncedFaq
                                      ? 'paybounced'
                                      : isGenioEcsClearanceFaq
                                        ? 'clearanceinfo'
                                        : item.type
                                  }_no`,
                                  'ecs_FAQ_feedback',
                                );
                                if (projectId === 'csportal') {
                                  const liVal = 'click';
                                  const liTrd = `faq_nothelpful`;
                                  const faqTypeVal = '';
                                  const othersData = [];
                                  const llTrd = `issue_ecs`;
                                  const llTrdInside = `faq_${item?.faqKey}`;
                                  await handleImpressionsTrack(
                                    liVal,
                                    liTrd,
                                    faqTypeVal,
                                    othersData,
                                    llTrd,
                                    authState,
                                    llTrdInside,
                                  );
                                }
                                if (item.type === 'bounce' || item.type === 'ecs-clearance') setIsHelful(true);
                                else setIsHelful(false);
                                helpfulfaqKeys[index] = { notHelpul: true, helpful: false };
                                setSearchQuestionelpfulFaqkeys({
                                  ...helpfulfaqKeys,
                                  [index]: { notHelpul: true, helpful: false },
                                });
                                handleSaveSessionStorage();
                                setShowData(false);
                                if (projectId === 'csportal') {
                                  handleShowTagsFeedback(appDispatch, { status: true, question: item?.question || '' });
                                }
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
}
EcsFaqs.propTypes = {
  faqdetails: PropTypes.array,
  campaigndetails: PropTypes.array,
  status: PropTypes.string,
  amount: PropTypes.string,
  redirectUrl: PropTypes.object,
  getAllEcsDetails: PropTypes.func,
  ecsdetails: PropTypes.object,
  projectId: PropTypes.string,
};
